<template>
    <isc-tooltip content="显示桌面">
        <header-action class="header-brand d-inline-flex align-center" @click="showDesktop">
            <img class="header-brand__logo" alt="" :src="brandLogo" />
            <span class="header-brand__name ml12">{{ brandName }}</span>
        </header-action>
    </isc-tooltip>
</template>

<script>
import brandLogo from '../../assets/app-brand.svg';
import HeaderAction from '@/components/desk-header/header-action';

export default {
    name: 'HeaderBrand',

    components: { HeaderAction },

    computed: {
        brandLogo() {
            return this.$store.state.desk.brandLogo || brandLogo;
        },

        brandName() {
            return this.$store.state.desk.brandName || '指令集物联网操作系统';
        }
    },

    methods: {
        showDesktop() {
            this.$store.commit('appManager/goHome');
        }
    }
};
</script>

<style lang="scss" scoped>
.header-brand {
    flex-shrink: 0;
    &__logo {
        max-height: 40px;
        max-width: 60px;
    }

    &__name {
        white-space: nowrap;
    }
}
</style>
